// VzmTextField.js
// Copyright to Lab is Fun, Inc. All rights reserved. 2024.
import React, { useState } from "react";
import { TextField } from "@mui/material";
//import { AppWord, AppConst } from "../value/VzmConst";
import { AppWord, InputType } from "../value/AppConst";
import IsValid from "../value/IsValid";
/**
 * Input field for text.
 * Uses input dictionary to determine its behavior.
 * @param {*} param0 
 * @returns 
 */
export default function VzmTextField({
    dict,
    value,
    label,
    disabled,
    onChange,
    onFocused,
    onBlur,
    onEnterKey,
    fullWidth,
    isPassword,
    inputProps,
    size,
    checkError,
    toUpperCase,
    style,
}) {
    const [error, setError] = useState(false);
    
    const onChangeValue = (e) => {
        let value = e.target.value;
        if(toUpperCase && value) value = value.toUpperCase();
        let valueError = false;
        if(dict.check) {
            valueError = dict.check(value) ? false : true;
            if(!valueError && checkError) valueError = checkError(value);
            setError(valueError);
        }
        else if(dict.max) {
            valueError = !IsValid.string(value, dict.min ? dict.min : dict.required ? 1 : 0, dict.max);
            setError(valueError);
        }
        if(onChange) onChange(dict.id, value, error);
    };

    const boolPasswd = isPassword || dict.type===InputType.password;

    const fieldInputProps = inputProps ? inputProps : dict.inputPropsStyle ? {style:dict.inputPropsStyle} : undefined;
    const givenStyle = style ? style : undefined;
    // inputProps deprecated. use slotProps.htmlInput instead.
    return(
        <TextField id={dict.id} size={size || dict.size || AppWord.MEDIUM}
            fullWidth={fullWidth}
            type={boolPasswd ? InputType.password : dict.type || InputType.text}
            label={label || dict.label}
            required={dict.required}
            value={value || ''}
            error={error}
            placeholder={dict.placeholder ? dict.placeholder : undefined}
            helperText={dict.errorHelp ? dict.errorHelp : undefined}
            onChange={onChangeValue}
            onFocus={()=>{if(onFocused) onFocused(dict)}}
            onBlur={()=>{if(onBlur) onBlur(dict)}}
            slotProps={{htmlInput: fieldInputProps}}
            disabled={disabled?true:false}
            onKeyDown={(e)=>{
                if(e.key==='Enter' && onEnterKey) onEnterKey();
            }}
            style={givenStyle}
        />
    );
}